module.exports = __webpack_public_path__ + "img/chevron-down-20px-dark.2c1d915.svg";